module.exports = __webpack_public_path__ + "img/imac-pro.f24ccbeb.svg";